import { jsPDF } from 'jspdf';
import {
  AP_AGING_BUCKETS,
  AP_AGING_BUCKET_LABELS
} from '../services/apAgingService';

const csvValue = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`;

const downloadBlob = (content, fileName, type) => {
  const url = URL.createObjectURL(new Blob([content], { type }));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};

const tableRows = (report) => [
  [
    'Vendor',
    ...AP_AGING_BUCKETS.map((bucket) => AP_AGING_BUCKET_LABELS[bucket]),
    'Total'
  ],
  ...report.vendors.map((vendor) => [
    vendor.name,
    ...AP_AGING_BUCKETS.map((bucket) => Number(vendor.buckets[bucket] || 0).toFixed(2)),
    Number(vendor.total || 0).toFixed(2)
  ]),
  [
    'Total Payables',
    ...AP_AGING_BUCKETS.map((bucket) => Number(report.grandTotals.buckets[bucket] || 0).toFixed(2)),
    Number(report.grandTotals.total || 0).toFixed(2)
  ]
];

export const downloadAPAgingCsv = ({ report, asOfDate }) => {
  const content = `\uFEFF${tableRows(report)
    .map((row) => row.map(csvValue).join(','))
    .join('\r\n')}`;

  downloadBlob(
    content,
    `Accounts_Payable_Aging_${asOfDate}.csv`,
    'text/csv;charset=utf-8;'
  );
};

export const downloadAPAgingPdf = ({ report, asOfDate }) => {
  const pdf = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'letter' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const margin = 36;
  let y = 42;

  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(16);
  pdf.setTextColor(24, 35, 30);
  pdf.text(report.businessName || 'Your Business', margin, y);
  y += 20;

  pdf.setFontSize(13);
  pdf.text('Accounts Payable Aging', margin, y);
  y += 15;

  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(9);
  pdf.setTextColor(90, 98, 92);
  pdf.text('Outstanding vendor balances organized by aging period.', margin, y);
  pdf.text(`As of ${asOfDate}`, pageWidth - margin, y, { align: 'right' });
  y += 24;

  const rows = tableRows(report);
  const widths = [150, 90, 90, 90, 90, 90, 100];
  const rowHeight = 20;

  rows.forEach((row, rowIndex) => {
    if (y > 540) {
      pdf.addPage();
      y = 42;
    }

    if (rowIndex === 0 || rowIndex === rows.length - 1) {
      pdf.setFillColor(244, 247, 245);
      pdf.rect(margin, y - 13, pageWidth - margin * 2, rowHeight, 'F');
      pdf.setFont('helvetica', 'bold');
    } else {
      pdf.setFont('helvetica', 'normal');
    }

    pdf.setFontSize(8.5);
    pdf.setTextColor(35, 45, 38);

    let x = margin;
    row.forEach((value, columnIndex) => {
      const width = widths[columnIndex];
      const align = columnIndex === 0 ? 'left' : 'right';
      const textX = align === 'right' ? x + width - 6 : x + 6;
      pdf.text(String(value), textX, y, { align });
      x += width;
    });

    pdf.setDrawColor(225, 230, 226);
    pdf.line(margin, y + 6, pageWidth - margin, y + 6);
    y += rowHeight;
  });

  pdf.save(`Accounts_Payable_Aging_${asOfDate}.pdf`);
};